import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import projectService from '../../services/projectService';
import './ProjectList.css';
import CommonModal from '../../services/CommonModal';
import { FiTrash, FiTrash2 } from 'react-icons/fi';
import resourceAllocationService from '../../services/resourceAllocationService';
import ProjectDescription from './ProjectDescription';
import { FaFileExcel } from 'react-icons/fa';

const ProjectList = ({ selectionMode = false, onSelect }) => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [enabled, setEnabled] = useState(false);

  const [viewMode, setViewMode] = useState('grid'); // 'grid' or 'tree'
  const navigate = useNavigate();
  const [filters, setFilters] = useState({
    status: '',
    priority: '',
    search: '',
    page: 1,
    limit: 20
  });
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [pagination, setPagination] = useState({});
  const [selectedProject, setSelectedProject] = useState(null);


  const confirmDelete = () => {
    console.log("uuuu")
    handleDelete(selectedProject.id);
    setShowDeleteModal(false);
  };


  useEffect(() => {
    fetchProjects();
  }, [filters]);

  const fetchProjects = async () => {
    try {
      setLoading(true);
      const data = await projectService.getAllProjects(filters);
      setProjects(data.projects || []);
      setPagination(data.pagination || {});
      setError(null);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to fetch projects');
      setProjects([]); // Set empty array on error
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    // if (!window.confirm('Are you sure you want to delete this project?')) {
    //   return;
    // }

    try {
      await projectService.deleteProject(id);
      fetchProjects();
    } catch (err) {
      alert(err.response?.data?.error || 'Failed to delete project');
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value, page: 1 }));
  };

  const handleProjectSelect = (project) => {
    if (selectionMode && onSelect) {
      setSelectedProject(project);
      onSelect(project);
    }
  };

  const getStatusBadge = (status) => {
    const statusColors = {
      'Planning': 'badge-secondary',
      'In Progress': 'badge-primary',
      'On Hold': 'badge-warning',
      'Completed': 'badge-success',
      'Cancelled': 'badge-danger'
    };
    return statusColors[status] || 'badge-secondary';
  };

  const getPriorityBadge = (priority) => {
    const priorityColors = {
      'Low': 'badge-info',
      'Medium': 'badge-warning',
      'High': 'badge-danger',
      'Critical': 'badge-danger-dark'
    };
    return priorityColors[priority] || 'badge-secondary';
  };
  // const formatDate = (date) => {
  //   if (!date) return 'N/A';
  //   return new Date(date).toLocaleDateString('en-US', {
  //     year: 'numeric',
  //     month: 'long',
  //     day: 'numeric'
  //   });
  // };
  if (loading && projects.length === 0) {
    return <div className="loading">Loading projects...</div>;
  }


  const handleToggle = async () => {
    const newValue = !enabled;
    setEnabled(newValue);

    try {
      const response = await projectService.getAllProjects(filters);

      if (newValue) {
        // ON → Archives
        console.log("uuuu", newValue, response)
        setProjects(response.projects_archive || []);
      } else {
        console.log("tttt", newValue)
        setProjects(response.projects || []);
      }
    } catch (err) {
      console.error("Failed to fetch projects:", err);
    }
  };

  const handleDownloadProjectList = () => {
    if (!projects || projects.length === 0) {
      alert('No projects to download');
      return;
    }

    const headers = [
      'Code', 'Name', 'Project Manager', 'Priority', 'Status',
      'Budget Allocated', 'Budget Spent', 'Progress %',
      'Resources Required', 'Resources Onboarded', 'Created At'
    ];

    const escapeCsv = (value) => {
      if (value === null || value === undefined) return '';
      const str = String(value);
      if (str.includes(',') || str.includes('"') || str.includes('\n')) {
        return `"${str.replace(/"/g, '""')}"`;
      }
      return str;
    };

    const rows = projects.map((project) => [
      project.code || 'N/A',
      project.name,
      project.project_manager
        ? `${project.project_manager.first_name} ${project.project_manager.last_name}`
        : '',
      project.priority,
      project.status,
      project.budget_allocated ?? '',
      project.budget_spent ?? '',
      project.progress_percentage ?? '',
      project.total_resources_required ?? 0,
      project.count_allocations ?? 0,
      project.createdAt ? new Date(project.createdAt).toLocaleDateString() : ''
    ]);

    const csvContent = [headers, ...rows]
      .map((row) => row.map(escapeCsv).join(','))
      .join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = `projects-${new Date().toISOString().slice(0, 10)}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <div className="project-list-container">
      {!selectionMode && (
        <div className="project-list-header">
          <h1>Projects</h1>
          <div className="flex gap-2">
            <Link to="/app/projects/new" className="btn btn-primary">
              <i className="fas fa-plus"></i> Create Project
            </Link>
            <button onClick={handleDownloadProjectList}
              className="px-4 py-4 bg-white border border-green-600 text-green-600 rounded-lg flex items-center gap-2"
              title="Download project list">
              <FaFileExcel />
            </button>
          </div>
        </div>
      )}

      {error && <div className="alert alert-danger">{error}</div>}
      <CommonModal
        isOpen={showDeleteModal}
        title="Delete project"
        message="Are you sure you want to delete this project?"
        onClose={() => {
          setShowDeleteModal(false);
          setSelectedProject(null);
        }}
        onConfirm={confirmDelete}
        type="error"
        confirmText="Delete"
        cancelText="Cancel"
      />

      <div className="filters filter-custom">
        <div className="filter-group">
          <input
            type="text"
            name="search"
            placeholder="Search projects..."
            value={filters.search}
            onChange={handleFilterChange}
            className="form-control filter-custom"
          />
        </div>
        <div className="filter-group">
          <select
            name="status"
            value={filters.status}
            onChange={handleFilterChange}
            className="form-control"
          >
            <option value="">All Status</option>
            <option value="Planning">Planning</option>
            <option value="In Progress">In Progress</option>
            <option value="On Hold">On Hold</option>
            <option value="Completed">Completed</option>
            <option value="Cancelled">Cancelled</option>
          </select>
        </div>
        <div className="filter-group">
          <select
            name="priority"
            value={filters.priority}
            onChange={handleFilterChange}
            className="form-control"
          >
            <option value="">All Priority</option>
            <option value="Low">Low</option>
            <option value="Medium">Medium</option>
            <option value="High">High</option>
            <option value="Critical">Critical</option>
          </select>
        </div>
      </div>


      <div className="view-toggle mb-4 flex items-center">
        <button
          className={`toggle-btn ${viewMode === "grid" ? "active" : ""
            }`}
          onClick={() => setViewMode("grid")}
        >
          <i className="fas fa-th"></i> Grid View
        </button>

        <button
          className={`toggle-btn ${viewMode === "tree" ? "active" : ""
            }`}
          onClick={() => setViewMode("tree")}
        >
          <i className="fas fa-sitemap"></i> List View
        </button>

        {/* Right aligned toggle */}
        <div className="ml-auto flex items-center gap-2">
          <span className="text-sm font-medium text-gray-700">
            {/* {enabled ? "Archive" : "Projects"} */}
            Archive
          </span>

          <label className="switch">
            <input
              type="checkbox"
              checked={enabled}
              onChange={handleToggle}
            />
            <span className="slider"></span>
          </label>
        </div>
      </div>


      {loading && projects.length === 0 ? (
        <div className="loading">Loading projects...</div>
      ) : projects.length === 0 ? (
        <div className="no-projects">
          <i className="fas fa-briefcase"></i>
          <p>No projects found</p>
          <Link to="/app/projects/new" className="btn btn-primary">
            Create Your First Portfolio
          </Link>
        </div>
      ) : viewMode === "grid" ? (
        <div className="project-list">
          {!projects || projects.length === 0 ? (
            <div className="no-projects">
              <p>No projects found</p>
              {!selectionMode && (
                <Link to="/app/projects/new" className="btn btn-primary">Create your first project</Link>
              )}
            </div>
          ) : (
            <div className="projects-grid">
              {projects.map(project => (
                <div
                  key={project.id}
                  className={`project-card ${selectionMode && selectedProject?.id === project.id ? 'selected' : ''}`}
                  onClick={() => selectionMode && handleProjectSelect(project)}
                >
                  <div className="project-card-header">
                    <div className="project-info">
                      <h3>
                        {selectionMode ? (
                          project.name
                        ) : (
                          <Link to={`/app/projects/${project.id}`}>{project.name}</Link>
                        )}
                      </h3>
                      <span className="project-code">{project.code}</span>
                    </div>
                    <div className="project-badges">
                      <span className={`badge ${getStatusBadge(project.status)}`}>
                        {project.status}
                      </span>
                      <span className={`badge ${getPriorityBadge(project.priority)}`}>
                        {project.priority}
                      </span>
                    </div>
                  </div>

                  <div className="project-card-body">
                    {/* <p className="project-description">{project.description}</p> */}

                    <ProjectDescription description={project.description} />

                    <div className="project-meta">
                      {project.project_manager && (
                        <div className="meta-item">
                          <i className="fas fa-user"></i>
                          <span>{project.project_manager.first_name} {project.project_manager.last_name}</span>
                        </div>
                      )}
                      {project.start_date && (
                        <div className="meta-item">
                          <i className="fas fa-calendar"></i>
                          <div title="Start Date">{resourceAllocationService.formatDate(project.start_date)}</div>
                          <div className="date-separator">→</div>
                          <div title="End Date">{project.end_date ? resourceAllocationService.formatDate(project.end_date) : 'N/A'}</div>
                        </div>
                      )}
                    </div>

                    <div className="project-meta">
                      {project.total_resources_required !== undefined && project.total_resources_required !== null && (
                        <div className="meta-item">
                          <i className="fas fa-users"></i>
                          <span>
                            Resources: <span style={{ color: 'orange' }}>Required:  {project.total_resources_required}</span>, <span style={{ color: 'green' }}>Onboarded:  {project.count_allocations ?? 0}</span>,
                          </span>
                          <span
                            className="cursor-pointer hover:underline"
                            onClick={() => navigate(`/app/resources/allocations/new`)}
                          >
                            <span style={{ color: 'red' }}> Yet to onboard:{" "}
                              {(project.count_allocations ?? 0) - (project.total_resources_required ?? 0)}</span>
                          </span>
                        </div>
                      )}
                    </div>

                    <div className="project-progress">
                      <div className="progress-header">
                        <span>Progress</span>
                        <span>{project.progress_percentage}%</span>
                      </div>
                      <div className="progress-bar">
                        <div
                          className="progress-fill"
                          style={{ width: `${project.progress_percentage}%` }}
                        ></div>
                      </div>
                    </div>

                    {project.budget_allocated && (
                      <div className="project-budget">
                        <div className="budget-item">
                          <span className="budget-label">Budget:</span>
                          <span className="budget-value">₹{project.budget_allocated.toLocaleString()}</span>
                        </div>
                        <div className="budget-item">
                          <span className="budget-label">Spent:</span>
                          <span className="budget-value">₹{project.budget_spent.toLocaleString()}</span>
                        </div>
                      </div>
                    )}
                  </div>

                  {!selectionMode && (
                    <div className="project-card-footer">
                      <Link
                        to={`/app/projects/${project.id}/edit`}
                        className="btn btn-sm btn-outline-primary"
                      >
                        <i className="fas fa-edit"></i> Edit
                      </Link>


                      {!enabled && (
                        <button
                          onClick={(e) => {
                            setShowDeleteModal(true);
                            setSelectedProject(project)
                          }}
                          className="btn btn-sm btn-outline-danger"
                        >
                          <i className="fas fa-trash"></i> Delete
                        </button>
                      )}


                    </div>
                  )}
                </div>
              ))}
            </div>
          )}

          {pagination.pages > 1 && (
            <div className="pagination">
              <button
                onClick={() => setFilters(prev => ({ ...prev, page: prev.page - 1 }))}
                disabled={filters.page === 1}
                className="btn btn-outline-primary"
              >
                Previous
              </button>
              <span className="page-info">
                Page {pagination.page} of {pagination.pages}
              </span>
              <button
                onClick={() => setFilters(prev => ({ ...prev, page: prev.page + 1 }))}
                disabled={filters.page === pagination.pages}
                className="btn btn-outline-primary"
              >
                Next
              </button>
            </div>
          )}
        </div>


      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Code
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Project
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Project Manger
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Priority
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Budget
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Status
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Created
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Resoureces Required
                </th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Actions
                </th>
              </tr>
            </thead>

            <tbody className="bg-white divide-y divide-gray-200">
              {projects.map((project) => (
                <tr key={project.id} className="hover:bg-gray-50">
                  {/* Portfolio */}

                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className="text-sm text-gray-900">
                      {project.code || "Na"}
                    </span>
                  </td>

                  <td className="px-6 py-4">
                    <p className="text-blue-600 hover:text-blue-800 font-medium">
                      <Link to={`/app/projects/${project.id}`}>{project.name}</Link>

                    </p>

                    {/* {project.description && (
                      <p className="text-sm text-gray-500 mt-1 truncate max-w-md">
                        {project.description}
                      </p>
                    )} */}
                  </td>

                  {/* Client */}
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className="text-sm text-gray-900">
                      {project.project_manager && (
                        <div className="meta-item">
                          <i className="fas fa-user"></i>
                          <span>{project.project_manager.first_name} {project.project_manager.last_name}</span>
                        </div>
                      )}
                    </span>
                  </td>

                  {/* Projects */}
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className={`badge ${getPriorityBadge(project.priority)}`}>
                      {project.priority}
                    </span>
                  </td>

                  <td className="px-6 py-4 whitespace-nowrap">
                    {project.budget_allocated && (
                      <p>₹{project.budget_allocated.toLocaleString() || '0.00'} / ₹{project.budget_spent.toLocaleString() || '0.00'}</p>
                    )}
                  </td>


                  {/* Status */}
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span
                      className={`px-2 py-1 text-xs font-medium rounded-full ${project.status === ""
                        ? "bg-gray-100 text-green-700"
                        : "bg-gray-100 text-gray-700"
                        }`}
                    >
                      {project.status || ""}
                    </span>
                  </td>



                  {/* Created Date */}
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {new Date(project.createdAt).toLocaleDateString()}
                  </td>

                  {/* Resources Required */}
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {project.total_resources_required !== undefined && project.total_resources_required !== null ? project.total_resources_required : 0}
                  </td>

                  {/* Actions */}
                  <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                    <Link
                      to={`/app/projects/${project.id}/edit`}
                      className="text-blue-600 hover:text-blue-900 mr-4"
                      title="Edit"
                    >
                      <i className="fas fa-edit"></i>
                    </Link>

                    {/* <button
                      onClick={(e) => {
                        setShowDeleteModal(true);
                        setSelectedProject(project)
                      }}
                      className="btn btn-sm btn-outline-danger"
                    >
                      <FiTrash />
                    </button> */}

                    {!enabled && (
                      <Link
                        onClick={(e) => {
                          setShowDeleteModal(true);
                          setSelectedProject(project);
                        }}
                        className="text-blue-600 hover:text-blue-900 mr-4"
                      >
                        <i className="fas fa-trash"></i>
                      </Link>
                    )}

                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}





      {pagination.pages > 1 && (
        <div className="pagination">
          <button
            onClick={() => setFilters(prev => ({ ...prev, page: prev.page - 1 }))}
            disabled={filters.page === 1}
            className="btn btn-outline-primary"
          >
            Previous
          </button>
          <span className="page-info">
            Page {pagination.page} of {pagination.pages}
          </span>
          <button
            onClick={() => setFilters(prev => ({ ...prev, page: prev.page + 1 }))}
            disabled={filters.page === pagination.pages}
            className="btn btn-outline-primary"
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default ProjectList;


